﻿
<div class="login-container">
    <div class="site-branding">
        <div class="site-logo">
            <img src="/assets/img/logo-quantille-white-lg.png" [alt]="state.config.t.title">
        </div>
    </div>
    <mat-card class="box">
        <div class="card-title">
            {{ 'LOGIN.' + (currentMode === 'login' ? 'TITLE' : 'FORGOTTEN_PASSWORD_TITLE') | translate }}
        </div>
        <mat-card-content>
            <mat-tab-group class="hide-labels" #tabs>
                <mat-tab label="Login Form"> 
                    <form [formGroup]="loginForm">

                        <div class="input-label">{{ 'LOGIN.EMAIL_OR_USERNAME' | translate }}</div>
                        <mat-form-field appearance="fill">
                            <input matInput class="no-bkg" type="text" name="username" formControlName="username" autocomplete="username" required>
                            <mat-error msg></mat-error>
                        </mat-form-field>

                        <div class="input-label">{{ 'LOGIN.PASSWORD' | translate }}</div>
                        <mat-form-field appearance="fill">
                            <input matInput class="no-bkg" type="password" namme="password" formControlName="password" autocomplete="current-password" required>
                            <mat-error msg></mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="fill">
                            <mat-label>{{ 'LOGIN.LANGUAGE' | translate }}</mat-label>
                            <mat-select formControlName="lang" (selectionChange)="onLanguageChange($event.value)">
                                <mat-option *ngFor="let lang of supportedLanguages" [value]="lang.code">{{ lang.name }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </form>
                </mat-tab>
                <mat-tab label="Forgotten Password Form"> 
                    <form [formGroup]="passwordForm">
                        
                        <div class="input-label">{{ 'LOGIN.EMAIL_OR_USERNAME' | translate }}</div>
                        <mat-form-field appearance="fill" class="mb-70">
                            <input matInput class="no-bkg" type="text" name="username" formControlName="username" autocomplete="username" required>
                            <mat-error msg></mat-error>
                        </mat-form-field>                        
                    </form>
                </mat-tab>                
              </mat-tab-group>

            
        </mat-card-content>
            
        <div class="action-buttons">
            <button mat-flat-button color="accent" (click)="ok()">{{ 'LOGIN.' + (currentMode === 'login' ? 'LOGIN_BUTTON' : 'SEND_BUTTON') | translate }}</button>
            <button mat-flat-button color="primary" class="passwordreset button-lg" (click)="switchMode()">{{ 'LOGIN.' + (currentMode === 'login' ? 'FORGOTTEN_PASSWORD_TITLE' : 'BACK_BUTTON') | translate }}</button>
        </div>
            
    </mat-card>    
</div>
